/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Journey,
    JourneyFromJSON,
    JourneyFromJSONTyped,
    JourneyToJSON,
} from './';

/**
 * 
 * @export
 * @interface JourneyTTLOCriteriaInput
 */
export interface JourneyTTLOCriteriaInput {
    /**
     * 
     * @type {boolean}
     * @memberof JourneyTTLOCriteriaInput
     */
    exclude?: boolean;
    /**
     * 
     * @type {Journey}
     * @memberof JourneyTTLOCriteriaInput
     */
    value?: Journey;
}

export function JourneyTTLOCriteriaInputFromJSON(json: any): JourneyTTLOCriteriaInput {
    return JourneyTTLOCriteriaInputFromJSONTyped(json, false);
}

export function JourneyTTLOCriteriaInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): JourneyTTLOCriteriaInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : JourneyFromJSON(json['value']),
    };
}

export function JourneyTTLOCriteriaInputToJSON(value?: JourneyTTLOCriteriaInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': JourneyToJSON(value.value),
    };
}


